import { render } from "./LocalVideoControlButton.vue?vue&type=template&id=d2caa77e&scoped=true"
import script from "./LocalVideoControlButton.vue?vue&type=script&lang=js"
export * from "./LocalVideoControlButton.vue?vue&type=script&lang=js"

import "./LocalVideoControlButton.vue?vue&type=style&index=0&id=d2caa77e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2caa77e"]])

export default __exports__